// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  background-color: #f5f5f5;\n}\n.App {\n  display: flex;\n  flex-flow: column;\n}\n.App__survey-msg {\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  padding-top: 5rem;\n  font-size: 2rem;\n  color: var(--primary-color);\n}\np {\n  margin: 0.5rem 0;\n}\nh3 {\n  margin: 2rem 0;\n}\nh4 {\n  font-size: 1.4rem;\n}\nlabel {\n  font-size: 1.4rem;\n}\na,\na:active,\na:hover,\na:visited {\n  color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
